import { DateTime } from "luxon"
import { ICompletedMessage, IErrorMessage, IExceptionMessage } from "./common"


export function getDefaultErrorMessage(statusCode: number): IErrorMessage {
    switch (statusCode) {
        case 401: {
            return { statusCode, type: "error", title: "Недостаточно прав" }
        }
        case 400: {
            return { statusCode, type: "error", title: "Некорректный запрос" }
        }
        case 404: {
            return { statusCode, type: "error", title: "Не найдено" }
        }
        default: {
            return { statusCode: statusCode, type: "error", title: "Ошибка сервера" }
        }
    }
}
export function getDefaultExceptionMessage(): IExceptionMessage {
    return { type: "exception", title: "Исключение при отправке. Детализация ошибки в логах." }
}
export function getDefaultCompletedMessage(statusCode: number): ICompletedMessage {
    switch (statusCode) {
        case 200: {
            return { statusCode, type: "success", text: "Успешно" }
        }
        case 201: {
            return { statusCode, type: "info", text: "Создано успешно" }
        }
        default: {
            return { statusCode, type: "success", text: "Успешно" }
        }
    }
}

export type LicenseExpiryStatus = 'normal' | 'warning' | 'critical';

export function getLicenseExpiryStatus(validTo: DateTime | null | undefined): LicenseExpiryStatus {
    if (!validTo || !validTo.isValid) return 'normal';

    const now = DateTime.now();
    const diffDays = Math.floor(validTo.diff(now, 'days').days);

    if (diffDays <= 7) return 'critical';   // ≤ 7 дней → красный
    if (diffDays <= 30) return 'warning';   // ≤ 30 и > 7 → жёлтый
    return 'normal';                         // > 30 → обычный
}

export function isLicenseExpiringSoon(validTo: DateTime | null | undefined, thresholdDays = 30): boolean {
    if (!validTo || !validTo.isValid) return false;
    const diffDays = Math.floor(validTo.diff(DateTime.now(), 'days').days);
    return diffDays <= thresholdDays && diffDays >= 0; // ≥0 — не истёк уже
}
